import React from 'react';
import MessageCard from '../MessageCard';
import GoogleLogo from './GoogleLogo';
import Stars from './Stars';
import Copy from '../../../../copy/Copy';

const GoogleReviewMessageCard = ({ hidden, rating }) => {
  if (hidden || !rating) return null;
  return (
    <MessageCard>
      <div style={{ display: 'flex', gap: '8px' }}>
        <GoogleLogo />
        <div>
          <span style={{ fontSize: '15px' }}>
            <Copy>googleMessage</Copy>
          </span>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyItems: 'center',
              fontSize: '20px',
            }}
          >
            <b>{rating}</b>
            <Stars rating={rating} />
          </div>
        </div>
      </div>
    </MessageCard>
  );
};

export default GoogleReviewMessageCard;
